/* ============================================
   Site Map Accordion — site-map.js
   ============================================ */

(function () {
  'use strict';

  function initSiteMap() {
    var sections = document.querySelectorAll('.sm-section');

    sections.forEach(function (section) {
      if (section.dataset.smInitialized === 'true') return;
      section.dataset.smInitialized = 'true';

      var headers = section.querySelectorAll('.sm-accordion-header');

      headers.forEach(function (header) {
        header.addEventListener('click', function (e) {
          // Don't toggle if user clicked the inner collection link
          if (e.target.closest('.sm-collection-link')) return;

          var expanded = header.getAttribute('aria-expanded') === 'true';
          var panel = section.querySelector('#' + header.getAttribute('aria-controls'));

          if (!panel) return;

          if (expanded) {
            // Close
            panel.style.maxHeight = panel.scrollHeight + 'px'; // set current height before collapse
            requestAnimationFrame(function () {
              panel.style.maxHeight = '0px';
            });
            header.setAttribute('aria-expanded', 'false');

            // Hide after transition completes
            panel.addEventListener('transitionend', function handler() {
              if (header.getAttribute('aria-expanded') === 'false') {
                panel.hidden = true;
                panel.style.maxHeight = '';
              }
              panel.removeEventListener('transitionend', handler);
            });
          } else {
            // Open
            panel.hidden = false;
            panel.style.maxHeight = '0px';
            requestAnimationFrame(function () {
              panel.style.maxHeight = panel.scrollHeight + 'px';
            });
            header.setAttribute('aria-expanded', 'true');

            // Reset max-height after transition for responsive resize
            panel.addEventListener('transitionend', function handler() {
              if (header.getAttribute('aria-expanded') === 'true') {
                panel.style.maxHeight = 'none';
              }
              panel.removeEventListener('transitionend', handler);
            });
          }
        });

        // Keyboard support: Enter / Space already triggers <button> click
        // Add Arrow Up/Down navigation between accordion headers
        header.addEventListener('keydown', function (e) {
          var headerArr = Array.prototype.slice.call(headers);
          var currentIndex = headerArr.indexOf(header);
          var nextIndex = null;

          if (e.key === 'ArrowDown') {
            e.preventDefault();
            nextIndex = (currentIndex + 1) % headerArr.length;
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            nextIndex = (currentIndex - 1 + headerArr.length) % headerArr.length;
          } else if (e.key === 'Home') {
            e.preventDefault();
            nextIndex = 0;
          } else if (e.key === 'End') {
            e.preventDefault();
            nextIndex = headerArr.length - 1;
          }

          if (nextIndex !== null) {
            headerArr[nextIndex].focus();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSiteMap);
  } else {
    initSiteMap();
  }

  // Re-init for Shopify Theme Editor live reloads
  document.addEventListener('shopify:section:load', initSiteMap);

})();